import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { text } from "@fortawesome/fontawesome-svg-core";
import { faTimesCircle } from "@fortawesome/pro-solid-svg-icons";

import { colors } from "UI/colors";

FnrModalCloseButton.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default function FnrModalCloseButton({ onClick, style }) {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <CloseButton
      data-cy="fnrModalCloseButton"
      onClick={handleClick}
      style={style}
    >
      <FontAwesomeIcon icon={faTimesCircle} />
    </CloseButton>
  );
}

const CloseButton = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 18px;
  cursor: pointer;
  color: #aeadad;
  transition: color 200ms;

  &:hover {
    color: ${colors.fnBlue};
  }

  &:active {
    transform: translateY(1px);
  }
`;
